import http from '@/utils/request'

const apis = {
  /**
   *生长模型
   */
  // 查询生长模型列表
  getGrowthModelList(dto) {
    return http.get({
      url: '/pc/growthModel/list',
      data: dto
    })
  },
  // 查询全部生长模型列表
  getGrowthModelAll(dto) {
    return http.get({
      url: '/pc/growthModel/getModelListByCropId',
      data: dto
    })
  },
  // 查询生长模型
  getGrowthModel(dto) {
    return http.get({
      url: '/pc/growthModel/getGrowthModel',
      data: dto
    })
  },
  // 保存生长模型
  saveGrowthModel(dto) {
    return http.post({
      url: '/pc/growthModel/saveGrowthModel',
      data: dto
    })
  },
  // 删除生长模型
  delGrowthModel(id) {
    return http.post({
      url: '/pc/growthModel/delGrowthModel',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  /**
   *生长模型配置数据
   */
  // 查询生长模型配置数据
  getGrowthModelData(dto) {
    return http.get({
      url: '/pc/growthModelDetail/getGrowthModelDetail',
      data: dto
    })
  },
  // 保存生长模型配置数据
  saveGrowthModelData(dto) {
    return http.post({
      url: '/pc/growthModelDetail/saveGrowthModelDetail',
      data: dto,
      typea: 1
    })
  },
  // 导出生长模型配置数据
  exportGrowthModelData(dto) {
    return http.post({
      url: '/pc/growthModelDetail/export',
      data: dto
    })
  },
  // 根据生长模型id获取分组列表
  getGreenHouseList(dto) {
    return http.get({
      url: '/pc/growthModelDetail/getGroupListById',
      data: dto
    })
  },

  /**
   *生长模型环境参数
   */
  // 查询生长模型环境参数列表
  getGrowthModelEvnParamList(dto) {
    return http.get({
      url: '/pc/growthModelEvnParam/getGrowthModelEvnParamList',
      data: dto
    })
  },
  // 查询全部生长模型环境参数
  getGrowthModelEvnParamAll(dto) {
    return http.get({
      url: '/pc/growthModelEvnParam/getGrowthModelEvnParamAll',
      data: dto
    })
  },
  // 查询生长模型环境参数
  getGrowthModelEvnParam(dto) {
    return http.get({
      url: '/pc/growthModelEvnParam/getGrowthModelEvnParam',
      data: dto
    })
  },
  // 保存生长模型环境参数
  saveGrowthModelEvnParam(dto) {
    return http.post({
      url: '/pc/growthModelEvnParam/saveGrowthModelEvnParam',
      data: dto
    })
  },
  // 删除生长模型环境参数
  delGrowthModelEvnParam(id) {
    return http.post({
      url: '/pc/growthModelEvnParam/delGrowthModelEvnParam',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },
  // 启用/禁用生长模型环境参数
  openOrCloseGrowthModelEvnParam(dto) {
    return http.post({
      url: '/pc/growthModelEvnParam/change',
      data: dto
    })
  },

  /**
   *生长模型数值设备
   */
  // 查询生长模型数值设备列表
  getGrowthModelDeviceNumericalList(dto) {
    return http.get({
      url: '/pc/growthModelDeviceNumerical/getGrowthModelDeviceNumericalList',
      data: dto
    })
  },
  // 查询全部生长模型数值设备
  getGrowthModelDeviceNumericalAll(dto) {
    return http.get({
      url: '/pc/growthModelDeviceNumerical/getGrowthModelDeviceNumericalAll',
      data: dto
    })
  },
  // 查询生长模型数值设备
  getGrowthModelDeviceNumerical(dto) {
    return http.get({
      url: '/pc/growthModelDeviceNumerical/getGrowthModelDeviceNumerical',
      data: dto
    })
  },
  // 保存生长模型数值设备
  saveGrowthModelDeviceNumerical(dto) {
    return http.post({
      url: '/pc/growthModelDeviceNumerical/saveGrowthModelDeviceNumerical',
      data: dto
    })
  },
  // 删除生长模型数值设备
  delGrowthModelDeviceNumerical(id) {
    return http.post({
      url: '/pc/growthModelDeviceNumerical/delGrowthModelDeviceNumerical',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  /**
   *生长模型阶段控制设备
   */
  // 查询生长模型阶段控制设备列表
  getGrowthModelStageControlList(dto) {
    return http.get({
      url: '/pc/growthModelStageControl/getGrowthModelStageControlList',
      data: dto
    })
  },
  // 查询全部生长模型阶段控制设备
  getGrowthModelStageControlAll(dto) {
    return http.get({
      url: '/pc/growthModelStageControl/getGrowthModelStageControlAll',
      data: dto
    })
  },
  // 查询生长模型阶段控制设备
  getGrowthModelStageControl(dto) {
    return http.get({
      url: '/pc/growthModelStageControl/getGrowthModelStageControl',
      data: dto
    })
  },
  // 保存生长模型阶段控制设备
  saveGrowthModelStageControl(dto) {
    return http.post({
      url: '/pc/growthModelStageControl/saveGrowthModelStageControl',
      data: dto
    })
  },
  // 删除生长模型阶段控制设备
  delGrowthModelStageControl(id) {
    return http.post({
      url: '/pc/growthModelStageControl/delGrowthModelStageControl',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  /**
   *生长模型开关设备
   */
  // 查询生长模型开关设备列表
  getGrowthModelDeviceSwitchList(dto) {
    return http.get({
      url: '/pc/growthModelDeviceSwitch/getGrowthModelDeviceSwitchList',
      data: dto
    })
  },
  // 查询全部生长模型开关设备
  getGrowthModelDeviceSwitchAll(dto) {
    return http.get({
      url: '/pc/growthModelDeviceSwitch/getGrowthModelDeviceSwitchAll',
      data: dto
    })
  },
  // 查询生长模型开关设备
  getGrowthModelDeviceSwitch(dto) {
    return http.get({
      url: '/pc/growthModelDeviceSwitch/getGrowthModelDeviceSwitch',
      data: dto
    })
  },
  // 查询生长模型全部设备类型
  getDeviceTypes(dto) {
    return http.get({
      url: '/pc/growthModelDeviceSwitch/getDeviceTypes',
      data: dto
    })
  },
  // 保存生长模型开关设备
  saveGrowthModelDeviceSwitch(dto) {
    return http.post({
      url: '/pc/growthModelDeviceSwitch/saveGrowthModelDeviceSwitch',
      data: dto
    })
  },
  // 删除生长模型开关设备
  delGrowthModelDeviceSwitch(id) {
    return http.post({
      url: '/pc/growthModelDeviceSwitch/delGrowthModelDeviceSwitch',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },
  // 启用/禁用生长模型开关设备
  openOrCloseGrowthModelDeviceSwitch(dto) {
    return http.post({
      url: '/pc/growthModelDeviceSwitch/change',
      data: dto
    })
  },

  /**
   *生长模型阶段外部设备
   */
  // 查询生长模型阶段外部设备列表
  getGrowthModelStageDeviceOutList(dto) {
    return http.get({
      url: '/pc/growthModelStageDeviceOut/getGrowthModelStageDeviceOutList',
      data: dto
    })
  },
  // 查询全部生长模型阶段外部设备
  getGrowthModelStageDeviceOutAll(dto) {
    return http.get({
      url: '/pc/growthModelStageDeviceOut/getGrowthModelStageDeviceOutAll',
      data: dto
    })
  },
  // 查询生长模型阶段外部设备
  getGrowthModelStageDeviceOut(dto) {
    return http.get({
      url: '/pc/growthModelStageDeviceOut/getGrowthModelStageDeviceOut',
      data: dto
    })
  },
  // 保存生长模型阶段外部设备
  saveGrowthModelStageDeviceOut(dto) {
    return http.post({
      url: '/pc/growthModelStageDeviceOut/saveGrowthModelStageDeviceOut',
      data: dto
    })
  },
  // 删除生长模型阶段外部设备
  delGrowthModelStageDeviceOut(id) {
    return http.post({
      url: '/pc/growthModelStageDeviceOut/delGrowthModelStageDeviceOut',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  /**
   *生长模型阶段设备
   */
  // 查询生长模型阶段设备列表
  getGrowthModelStageDeviceList(dto) {
    return http.get({
      url: '/pc/growthModelStageDevice/getGrowthModelStageDeviceList',
      data: dto
    })
  },
  // 查询全部生长模型阶段设备
  getGrowthModelStageDeviceAll(dto) {
    return http.get({
      url: '/pc/growthModelStageDevice/getGrowthModelStageDeviceAll',
      data: dto
    })
  },
  // 查询生长模型阶段设备
  getGrowthModelStageDevice(dto) {
    return http.get({
      url: '/pc/growthModelStageDevice/getGrowthModelStageDevice',
      data: dto
    })
  },
  // 保存生长模型阶段设备
  saveGrowthModelStageDevice(dto) {
    return http.post({
      url: '/pc/growthModelStageDevice/saveGrowthModelStageDevice',
      data: dto
    })
  },
  // 删除生长模型阶段设备
  delGrowthModelStageDevice(id) {
    return http.post({
      url: '/pc/growthModelStageDevice/delGrowthModelStageDevice',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },
  // 获取全部模型阶段控制优先（模型阶段id）
  getModelStageDevices(dto) {
    return http.get({
      url: '/pc/growthModelStageDevice/getModelStageDevices',
      data: dto
    })
  },
  // 保存模型阶段设备(批量保存)
  saveGrowthModelStageDeviceList(dto) {
    return http.post({
      url: '/pc/growthModelStageDevice/saveGrowthModelStageDevices',
      data: dto,
      typea: 1
    })
  },

  /**
   *阶段控制优先级
   */
  // 查询阶段控制优先级列表
  getGrowthModelStageControlPriorityList(dto) {
    return http.get({
      url: '/pc/growthModelStageControlPriority/getGrowthModelStageControlPriorityList',
      data: dto
    })
  },
  // 查询全部阶段控制优先级
  getGrowthModelStageControlPriorityAll(dto) {
    return http.get({
      url: '/pc/growthModelStageControlPriority/getGrowthModelStageControlPriorityAll',
      data: dto
    })
  },
  // 查询阶段控制优先级
  getGrowthModelStageControlPriority(dto) {
    return http.get({
      url: '/pc/growthModelStageControlPriority/getGrowthModelStageControlPriority',
      data: dto
    })
  },
  // 保存阶段控制优先级
  saveGrowthModelStageControlPriority(dto) {
    return http.post({
      url: '/pc/growthModelStageControlPriority/saveGrowthModelStageControlPriority',
      data: dto
    })
  },
  // 删除阶段控制优先级
  delGrowthModelStageControlPriority(id) {
    return http.post({
      url: '/pc/growthModelStageControlPriority/delGrowthModelStageControlPriority',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },
  // 获取全部模型阶段控制优先（模型阶段id）
  getGrowthModelStageControlPrioritys(dto) {
    return http.get({
      url: '/pc/growthModelStageControlPriority/getGrowthModelStageControlPrioritys',
      data: dto
    })
  },
  // 保存模型阶段控制优先（批量保存）
  saveGrowthModelStageControlPriorityList(dto) {
    return http.post({
      url: '/pc/growthModelStageControlPriority/saveGrowthModelStageControlPrioritys',
      data: dto,
      typea: 1
    })
  },

  /**
   *决策模型
   */
  // 查询决策模型列表
  getGrowthModelDecisionList(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getGrowthModelDecisionList',
      data: dto
    })
  },
  // 查询全部决策模型
  getGrowthModelDecisionAll(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getGrowthModelDecisionAll',
      data: dto
    })
  },
  // 查询决策模型
  getGrowthModelDecision(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getGrowthModelDecision',
      data: dto
    })
  },
  // 保存决策模型
  saveGrowthModelDecision(dto) {
    return http.post({
      url: '/pc/growthModelDecision/saveGrowthModelDecision',
      data: dto
    })
  },
  // 删除决策模型
  delGrowthModelDecision(id) {
    return http.post({
      url: '/pc/growthModelDecision/delGrowthModelDecision',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },
  exportGrowthModelDecisionSchedules(dto) {
    return http.get({
      url: '/pc/growthModelDecisionSchedule/exportGrowthModelDecisionSchedules',
      data: dto
    })
  },

  // 启用停用决策模型
  openOrCloseGrowthModelDecision(dto) {
    return http.post({
      url: '/pc/growthModelDecision/change2',
      data: dto
    })
  },
  /**
   *模型环境
   */
  // 查询模型环境列表
  getGrowthModelEvnList(dto) {
    return http.get({
      url: '/pc/growthModelEvn/getGrowthModelEvnList',
      data: dto
    })
  },
  // 查询全部模型环境
  getGrowthModelEvnAll(dto) {
    return http.get({
      url: '/pc/growthModelEvn/getGrowthModelEvnAll',
      data: dto
    })
  },
  // 查询模型环境
  getGrowthModelEvn(dto) {
    return http.get({
      url: '/pc/growthModelEvn/getGrowthModelEvn',
      data: dto
    })
  },
  // 保存模型环境
  saveGrowthModelEvn(dto) {
    return http.post({
      url: '/pc/growthModelEvn/saveGrowthModelEvn',
      data: dto
    })
  },
  // 删除模型环境
  delGrowthModelEvn(id) {
    return http.post({
      url: '/pc/growthModelEvn/delGrowthModelEvn',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },
  // 根据分组id查询农作物列表
  getGrowthCropAll(dto) {
    return http.get({
      url: '/pc/growthCrop/getGrowthCropByGroupId',
      data: dto
    })
  },
  // 获取全部生长阶段列表
  getGrowthModelStageAll(dto) {
    return http.get({
      url: '/pc/growthModelStage/getGrowthModelStageAll',
      data: dto
    })
  },
  // 获取全部生长周期列表
  getGrowthModelTimeAll(dto) {
    return http.get({
      url: '/pc/growthModelTime/getGrowthModelTimeAll',
      data: dto
    })
  },
  // 根据开关id属性id判断有没有正在运行的生长模型
  getModelStatus(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getModelStatus',
      data: dto
    })
  },
  /**
   *局部控制设备
   */
  // 查询局部控制设备列表
  getGrowthModelDeviceSwitchSecondList(dto) {
    return http.get({
      url: '/pc/growthModelDeviceSwitchSecond/getGrowthModelDeviceSwitchSecondList',
      data: dto
    })
  },
  // 查询局部控制设备
  getGrowthModelDeviceSwitchSecond(dto) {
    return http.get({
      url: '/pc/growthModelDeviceSwitchSecond/getGrowthModelDeviceSwitchSecond',
      data: dto
    })
  },
  // 保存局部控制设备
  saveGrowthModelDeviceSwitchSecond(dto) {
    return http.post({
      url: '/pc/growthModelDeviceSwitchSecond/saveGrowthModelDeviceSwitchSecond',
      data: dto,
      typea: 1
    })
  },
  // 删除局部控制设备
  delGrowthModelDeviceSwitchSecond(id) {
    return http.post({
      url: '/pc/growthModelDeviceSwitchSecond/delGrowthModelDeviceSwitchSecond',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },
  // 开关设备启用/禁用/删除提醒判断(模型设备id)
  judge(dto) {
    return http.get({
      url: 'pc/growthModelDeviceSwitch/judge',
      data: dto
    })
  },
  // 查询全部局部控制设备
  getGrowthModelDeviceSwitchSecondAll(dto) {
    return http.get({
      url: '/pc/growthModelDeviceSwitchSecond/getGrowthModelDeviceSwitchSecondAll',
      data: dto
    })
  },
  // 保存生长模型开关设备二阶段（批量保存）
  saveModelDeviceSwitchSecondList(dto) {
    return http.post({
      url: '/pc/growthModelDeviceSwitchSecond/saveModelDeviceSwitchSeconds',
      data: dto,
      typea: 1
    })
  },

  /**
   *设备标签
   */
  // 查询设备标签列表
  getGrowthModelDeviceSignList(dto) {
    return http.get({
      url: '/pc/growthModelDeviceSign/getGrowthModelDeviceSignList',
      data: dto
    })
  },
  // 查询全部设备标签
  getGrowthModelDeviceSigns(dto) {
    return http.get({
      url: '/pc/growthModelDeviceSign/getGrowthModelDeviceSigns',
      data: dto
    })
  },
  // 查询设备标签
  getGrowthModelDeviceSign(dto) {
    return http.get({
      url: '/pc/growthModelDeviceSign/getGrowthModelDeviceSign',
      data: dto
    })
  },
  // 保存设备标签
  saveGrowthModelDeviceSign(dto) {
    return http.post({
      url: '/pc/growthModelDeviceSign/saveGrowthModelDeviceSign',
      data: dto,
      typea: 1
    })
  },
  // 删除设备标签
  delGrowthModelDeviceSign(id) {
    return http.post({
      url: '/pc/growthModelDeviceSign/delGrowthModelDeviceSign',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  // 获取分组设备（可使用设备）
  getControlDevices(dto) {
    return http.get({
      url: '/pc/growthModelDeviceSign/getControlDevices',
      data: dto
    })
  },

  // 获取分组设备（移除设备）
  getRemoveControlDevices(dto) {
    return http.get({
      url: '/pc/growthModelDeviceSign/getRemoveControlDevices',
      data: dto
    })
  },

  // 检测接口-数据完整（决策模型id）
  checkGrowthModelDecisionData(dto) {
    return http.post({
      url: '/pc/growthModelDecision/checkGrowthModelDecision',
      data: dto,
      typea: 1
    })
  },
  // 检测接口-离线设备（决策模型id）
  checkGrowthModelDecisionOutlineDevices(dto) {
    return http.post({
      url: '/pc/growthModelDecision/checkGrowthModelDecisionOutlineDevices',
      data: dto,
      typea: 1
    })
  },

  // 获取生长模型配置详情
  getNewGrowthModelDetail(dto) {
    return http.get({
      url: '/pc/growthModel/getNewGrowthModelDetail',
      data: dto
    })
  },

  // 保存生长模型配置数据
  saveNewGrowthModelDetail(dto) {
    return http.post({
      url: '/pc/growthModelDetail/saveNewGrowthModelDetail',
      data: dto,
      typea: 1
    })
  },

  // 绑定摄像头
  bandingVideo(dto) {
    return http.post({
      url: '/pc/growthModelDecision/bandingDevice',
      data: dto,
      typea: 1
    })
  },

  // 绑定城市
  bandingCity(dto) {
    return http.post({
      url: '/pc/growthModelDecision/bandingCity',
      data: dto,
      typea: 1
    })
  },

  // 获取城市
  getCity(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getLocation',
      data: dto
    })
  },

  // 获取城市（决策模型id）
  getLocationByDecision(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getLocationByDecision',
      data: dto
    })
  },

  // 获取作物生长记录列表（决策模型id）
  getDataHisCropGrowthList(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getDataHisCropGrowthList',
      data: dto
    })
  },
  getGrowthModelDecisionHisDataSendList(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getGrowthModelDecisionHisDataSendList',
      data: dto
    })
  },
  getGrowthModelDecisonDataControlList(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getGrowthModelDecisonDataControlList',
      data: dto
    })
  },
  // 获取天气告警（决策模型id）
  getWeatherAlarm(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getWeatherAlarm',
      data: dto
    })
  },

  // 获取实时天气（决策模型id）
  getNowWeather(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getNowWeather',
      data: dto
    })
  },

  // 获取天气3天预报（决策模型id）
  getPreWeather(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getPreWeather',
      data: dto
    })
  },

  // 获取天气3天预报（决策模型id）
  getGrowthModelAttributes(dto) {
    return http.get({
      url: '/pc/growthModelDetail/getGrowthModelAttributes',
      data: dto
    })
  },

  // 确认周期（决策模型id）
  updateCycleStatus(dto) {
    return http.post({
      url: '/pc/growthModelDecision/updateCycleStatus',
      data: dto,
      typea: 1
    })
  },

  // 增加周期时长
  plusCycleTime(dto) {
    return http.post({
      url: '/pc/growthModelDecision/plusCycleTime',
      data: dto,
      typea: 1
    })
  },

  // 获取模型使用记录列表（生长模型id）
  getDataGrowthModelUserLogList(dto) {
    return http.get({
      url: '/pc/growthModelDetail/getDataGrowthModelUserLogList',
      data: dto
    })
  },

  // 查询生长模型详情（新 加密）
  getNewGrowthModelDetailByEncryption(dto) {
    return http.get({
      url: '/pc/growthModel/getNewGrowthModelDetailByEncryption',
      data: dto
    })
  },

  // 保存生长模型数据（新 解密）
  saveNewGrowthModelDetailBydecryption(dto) {
    return http.post({
      url: '/pc/growthModelDetail/saveNewGrowthModelDetailBydecryption',
      data: dto,
      typea: 1
    })
  },

  // 灯光初始化(模型参数id)
  initLightControl(dto) {
    return http.post({
      url: '/pc/growthModelLightControl/initLightControl',
      data: dto,
      typea: 1
    })
  },

  /**
   *授权用户
   */
  // 查询授权用户列表
  getGrowthModelUserList(dto) {
    return http.get({
      url: '/pc/growthModelUser/getGrowthModelUserList',
      data: dto
    })
  },
  // 查询全部授权用户列表
  getGrowthModelUsers(dto) {
    return http.get({
      url: '/pc/growthModelUser/getGrowthModelUsers',
      data: dto
    })
  },
  // 查询授权用户
  getGrowthModelUser(dto) {
    return http.get({
      url: '/pc/growthModelUser/getGrowthModelUser',
      data: dto
    })
  },
  // 保存授权用户
  saveGrowthModelUser(dto) {
    return http.post({
      url: '/pc/growthModelUser/saveGrowthModelUser',
      data: dto
    })
  },
  // 删除授权用户
  delGrowthModelUser(id) {
    return http.post({
      url: '/pc/growthModelUser/deleteGrowthModelUser',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },
  // 获取决策模型和农事记录时间轴图表
  getTimeAxisChart(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getTimeAxisChart2',
      data: dto
    })
  },
  // 查询决策模型定时任务下发记录列表
  getGrowthModelDecisionScheduleHisDataSendList(dto) {
    return http.get({
      url: '/pc/growthModelDecisionSchedule/getGrowthModelDecisionScheduleHisDataSendList',
      data: dto
    })
  },
  // 获取决策模型和获取农事记录列表时间轴图表
  getAppProductionFarmRecordList(dto) {
    return http.get({
      url: '/app-api/productionFarmRecord/getAppProductionFarmRecordList',
      data: dto
    })
  },
  getProductionWorkBackList(dto) {
    return http.get({
      url: '/production_webservice/productionWork/getProductionWorkBackList',
      data: dto
    })
  },
  getProductionFertilizerList(dto) {
    return http.get({
      url: '/production_webservice/productionFertilizer/getProductionFertilizerList',
      data: dto
    })
  },
  getPlanDate(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getPlanDate',
      data: dto
    })
  },
  getGrowthModelFertilizerByUser(dto) {
    return http.get({
      url: '/pc/growthModelFertilizer/getGrowthModelFertilizerByUser',
      data: dto
    })
  },
  // 灯光初始化(模型参数id)
  sendCmdToBox(dto) {
    return http.post({
      url: '/pc/growthModelDecision/sendCmdToBox',
      data: dto,
      typea: 1
    })
  },
  // 获取全部决策模型定时任务
  getGrowthModelDecisionSchedules(dto) {
    return http.get({
      url: '/pc/growthModelDecisionSchedule/getGrowthModelDecisionSchedules',
      data: dto
    })
  },
  // 获取决策模型定时任务
  getGrowthModelDecisionSchedule(dto) {
    return http.get({
      url: '/pc/growthModelDecisionSchedule/getGrowthModelDecisionSchedule',
      data: dto
    })
  },

  // 删除决策模型定时任务
  delGrowthModelDecisionSchedule(id) {
    return http.post({
      url: '/pc/growthModelDecisionSchedule/delGrowthModelDecisionSchedule',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },
  // 删除生长模型环境参数
  delObjDeviceSwtichAttrVideo(id) {
    return http.post({
      url: '/pc/objDeviceSwtichAttrVideo/delObjDeviceSwtichAttrVideo',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },
  // 保存决策模型定时任务
  saveGrowthModelDecisionSchedule(dto) {
    return http.post({
      url: '/pc/growthModelDecisionSchedule/saveGrowthModelDecisionSchedule',
      data: dto,
      typea: 1
    })
  },
  // 决策模型定时任务下发（决策模型id）
  sendGrowthModelDecisionScheduleCmd(dto) {
    return http.post({
      url: '/pc/growthModelDecisionSchedule/sendGrowthModelDecisionScheduleCmd',
      data: dto
    })
  },
  // 获取农事类型
  getProductionWorkType(dto) {
    return http.get({
      url: '/pc/productionWorkType/getProductionWorkType',
      data: dto
    })
  },
  // 获取农事类型列表
  getProductionWorkTypeList(dto) {
    return http.get({
      url: '/pc/productionWorkType/getProductionWorkTypeList',
      data: dto
    })
  },
  // 获取全部农事类型列表
  getProductionWorkTypes(dto) {
    return http.get({
      url: '/pc/productionWorkType/getProductionWorkTypes',
      data: dto
    })
  },
  // 保存农事类型
  saveProductionWorkType(dto) {
    return http.post({
      url: '/pc/productionWorkType/saveProductionWorkType',
      data: dto,
      typea: 1
    })
  },
  // 删除农事类型
  // delProductionWorkType(dto) {
  //   return http.del({
  //     url: '/pc/productionWorkType/delProductionWorkType',
  //     data: dto
  //   })
  // },
  // 获取农事作业记录
  getProductionWork(dto) {
    return http.get({
      url: '/pc/productionWork/getProductionWork',
      data: dto
    })
  },
  // 获取农事作业记录列表
  getProductionWorkList(dto) {
    return http.get({
      url: '/pc/productionWork/getProductionWorkList',
      data: dto
    })
  },
  // 保存农事作业记录
  saveProductionWork(dto) {
    return http.post({
      url: '/pc/productionWork/saveProductionWork',
      data: dto,
      typea: 1
    })
  },
  // 删除农事作业记录
  // delProductionWork(dto) {
  //   return http.del({
  //     url: '/pc/productionWork/delProductionWork',
  //     data: dto
  //   })
  // },
  // 删除历史报文下发任务
  deleteDataHisCmdTask(id) {
    return http.post({
      url: '/pc/dataHisCmdTask/deleteDataHisCmdTask',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },
  // 获取全部历史报文下发任务详情（任务id）
  getDataHisCmdTaskDetails(dto) {
    return http.get({
      url: '/pc/dataHisCmdTask/getDataHisCmdTaskDetails',
      data: dto
    })
  },
  // 获取历史报文下发任务列表
  getDataHisCmdTaskList(dto) {
    return http.get({
      url: '/pc/dataHisCmdTask/getDataHisCmdTaskList',
      data: dto
    })
  },
  // 获取全部历史报文下发任务
  getDataHisCmdTasks(dto) {
    return http.get({
      url: '/pc/dataHisCmdTask/getDataHisCmdTasks',
      data: dto
    })
  },
  //任务命令下发
  sendTask(dto) {
    return http.post({
      url: '/pc/dataHisCmdTask/sendTask',
      data: dto
    })
  },
  // 获取作物信息
  getProductionCrop(dto) {
    return http.get({
      url: '/pc/productionCrop/getProductionCrop',
      data: dto
    })
  },
  // 获取作物信息列表
  getProductionCropList(dto) {
    return http.get({
      url: '/pc/productionCrop/getProductionCropList',
      data: dto
    })
  },
  // 获取全部作物信息列表(分组id)
  getProductionCrops(dto) {
    return http.get({
      url: '/pc/productionCrop/getProductionCrops',
      data: dto
    })
  },
  //保存作物信息
  saveProductionCrop(dto) {
    return http.post({
      url: '/pc/productionCrop/saveProductionCrop',
      data: dto,
      typea: 1
    })
  },

  // 获取农事设备
  getProductionDevice(dto) {
    return http.get({
      url: '/pc/productionDevice/getProductionDevice',
      data: dto
    })
  },
  // 获取农事设备列表
  getProductionDeviceList(dto) {
    return http.get({
      url: '/pc/productionDevice/getProductionDeviceList',
      data: dto
    })
  },
  // 获取全部农事设备列表(分组id)
  getProductionDevices(dto) {
    return http.get({
      url: '/pc/productionDevice/getProductionDevices',
      data: dto
    })
  },
  //保存农事设备
  saveProductionDevice(dto) {
    return http.post({
      url: '/pc/productionDevice/saveProductionDevice',
      data: dto,
      typea: 1
    })
  },

  // 获取农药信息
  getProductionPesticide(dto) {
    return http.get({
      url: '/pc/productionPesticide/getProductionPesticide',
      data: dto
    })
  },
  // 获取农药信息列表
  getProductionPesticideList(dto) {
    return http.get({
      url: '/pc/productionPesticide/getProductionPesticideList',
      data: dto
    })
  },

  // 获取全部农药信息列表(分组id)
  getProductionPesticides(dto) {
    return http.get({
      url: '/pc/productionPesticide/getProductionPesticides',
      data: dto
    })
  },
  //保存农药信息
  saveProductionPesticide(dto) {
    return http.post({
      url: '/pc/productionPesticide/saveProductionPesticide',
      data: dto,
      typea: 1
    })
  },

  // 获取员工信息
  getProductionStaff(dto) {
    return http.get({
      url: '/pc/productionStaff/getProductionStaff',
      data: dto
    })
  },
  // 获取员工信息列表
  getProductionStaffList(dto) {
    return http.get({
      url: '/pc/productionStaff/getProductionStaffList',
      data: dto
    })
  },
  // 获取全部员工信息列表(分组id)
  getProductionStaffs(dto) {
    return http.get({
      url: '/pc/productionStaff/getProductionStaffs',
      data: dto
    })
  },
  //保存员工信息
  saveProductionStaff(dto) {
    return http.post({
      url: '/pc/productionStaff/saveProductionStaff',
      data: dto,
      typea: 1
    })
  },
  //控制柜模式修改
  changeBox(dto) {
    return http.post({
      url: '/pc/growthModelDecision/changeBox',
      data: dto
    })
  },

  getBoxStatus(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getBoxStatus',
      data: dto
    })
  },
  // 获取肥料信息
  getProductionFertilizer(dto) {
    return http.get({
      url: '/pc/productionFertilizer/getProductionFertilizer',
      data: dto
    })
  },
  // 获取肥料信息列表
  getProductionFertilizerList(dto) {
    return http.get({
      url: '/pc/productionFertilizer/getProductionFertilizerList',
      data: dto
    })
  },
  // 获取全部肥料信息列表(分组id)
  getProductionFertilizers(dto) {
    return http.get({
      url: '/pc/productionFertilizer/getProductionFertilizers',
      data: dto
    })
  },
  // 获取全部决策模型定时器设备控制组件表
  getGrowthModelDecisionScheduleComponets(dto) {
    return http.get({
      url: '/pc/growthModelDecisionSchedule/getGrowthModelDecisionScheduleComponets',
      data: dto
    })
  },
  //保存肥料信息
  saveProductionFertilizer(dto) {
    return http.post({
      url: 'pc/productionFertilizer/saveProductionFertilizer',
      data: dto,
      typea: 1
    })
  },
  //保存肥料信息
  saveGrowthModelDecisionScheduleComponets(dto) {
    return http.post({
      url: 'pc/growthModelDecisionSchedule/saveGrowthModelDecisionScheduleComponets',
      data: dto,
      typea: 1
    })
  },
  //保存肥料信息
  sendGrowthModelDecisionScheduleComponets(dto) {
    return http.post({
      url: 'pc/growthModelDecisionSchedule/sendGrowthModelDecisionScheduleComponets',
      data: dto,
      typea: 1
    })
  },
  sendGrowthModelDecisionScheduleCmd(dto) {
    return http.post({
      url: 'pc/growthModelDecisionSchedule/sendGrowthModelDecisionScheduleCmd',
      data: dto
    })
  },
  // 启用/禁用 决策模型定时任务
  updateGrowthModelDecisionScheduleStatus(dto) {
    return http.post({
      url: '/pc/growthModelDecisionSchedule/updateGrowthModelDecisionScheduleStatus',
      data: dto
    })
  },
  exportProductionWorkList(dto) {
    return http.post({
      url: '/pc/productionWork/exportProductionWorkList',
      data: dto,
      typea: 1
    })
  },

  getGrowthModelTimeAttributeValueConfigList(dto) {
    return http.get({
      url: '/pc/growthModelTimeAttributeValueConfig/getGrowthModelTimeAttributeValueConfigList',
      data: dto
    })
  },
  getGrowthModelTimeAttributeValueConfig(dto) {
    return http.get({
      url: '/pc/growthModelTimeAttributeValueConfig/getGrowthModelTimeAttributeValueConfig',
      data: dto
    })
  },
  getGrowthModelDecisionDeviceComponentsDataHisList(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getGrowthModelDecisionDeviceComponentsDataHisList',
      data: dto
    })
  },
  getGrowthModelDecisionDeviceComponents(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getGrowthModelDecisionDeviceComponents',
      data: dto
    })
  },
  getGrowthModelDecisionScheduleComponetsDataHisList(dto) {
    return http.get({
      url: '/pc/growthModelDecisionSchedule/getGrowthModelDecisionScheduleComponetsDataHisList',
      data: dto
    })
  },
  getGrowthModelEvnParamChart(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getGrowthModelEvnParamChart',
      data: dto
    })
  },
  getSwitchAndAlarmChart(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getSwitchAndAlarmChart',
      data: dto
    })
  },
  getWorkAndRemindsChart(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getWorkAndRemindsChart',
      data: dto
    })
  },
  saveGrowthModelTimeAttributeValueConfig(dto) {
    return http.post({
      url: '/pc/growthModelTimeAttributeValueConfig/saveGrowthModelTimeAttributeValueConfig',
      data: dto,
      typea: 1
    })
  },
  verifyPasswd(dto) {
    return http.post({
      url: '/pc/growthModelDecision/verifyPasswd',
      data: dto,
      typea: 1
    })
  },
  sendGrowthModelDecisionDeviceComponents(dto) {
    return http.post({
      url: '/pc/growthModelDecision/sendGrowthModelDecisionDeviceComponents',
      data: dto,
      typea: 1
    })
  },

  saveGrowthModelDecisionDeviceComponents(dto) {
    return http.post({
      url: '/pc/growthModelDecision/saveGrowthModelDecisionDeviceComponents',
      data: dto,
      typea: 1
    })
  },
  getGrowthModelTimeAttributeValueConfigTask(dto) {
    return http.get({
      url: '/pc/GrowthModelTimeAttributeValueConfigTask/getGrowthModelTimeAttributeValueConfigTask',
      data: dto
    })
  },
  getGrowthModelTimeAttributeValueConfigTaskList(dto) {
    return http.get({
      url: '/pc/GrowthModelTimeAttributeValueConfigTask/getGrowthModelTimeAttributeValueConfigTaskList',
      data: dto
    })
  },
  saveGrowthModelTimeAttributeValueConfigTask(dto) {
    return http.post({
      url: '/pc/GrowthModelTimeAttributeValueConfigTask/saveGrowthModelTimeAttributeValueConfigTask',
      data: dto,
      typea: 1
    })
  },

  updateGrowthModelTimeAttributeValueConfigTaskStatus(dto) {
    return http.post({
      url: '/pc/GrowthModelTimeAttributeValueConfigTask/updateGrowthModelTimeAttributeValueConfigTaskStatus',
      data: dto
    })
  },
  importProductionWork(dto) {
    return http.post({
      url: '/pc/productionWork/importProductionWork',
      data: dto,
      typea: 1
    })
  },
  getProductionRemindList(dto) {
    return http.get({
      url: '/pc/productionRemind/getProductionRemindList',
      data: dto
    })
  },
  getProductionRemind(dto) {
    return http.get({
      url: '/pc/productionRemind/getProductionRemind',
      data: dto
    })
  },
  getGrowthModelFertilizer(dto) {
    return http.get({
      url: '/pc/growthModelFertilizer/getGrowthModelFertilizer',
      data: dto
    })
  },
  getGrowthModelFertilizerList(dto) {
    return http.get({
      url: '/pc/growthModelFertilizer/getGrowthModelFertilizerList',
      data: dto
    })
  },
  saveGrowthModelFertilizer(dto) {
    return http.post({
      url: '/pc/growthModelFertilizer/saveGrowthModelFertilizer',
      data: dto,
      typea: 1
    })
  },
  getGrowthFertilizer(dto) {
    return http.get({
      url: '/pc/growthFertilizer/getGrowthFertilizer',
      data: dto
    })
  },
  getGrowthFertilizerList(dto) {
    return http.get({
      url: '/pc/growthFertilizer/getGrowthFertilizerList',
      data: dto
    })
  },
  saveGrowthFertilizer(dto) {
    return http.post({
      url: '/pc/growthFertilizer/saveGrowthFertilizer',
      data: dto,
      typea: 1
    })
  },
  getGrowthModelFertilizerUserList(dto) {
    return http.get({
      url: '/pc/growthModelFertilizerUser/getGrowthModelFertilizerUserList',
      data: dto
    })
  },
  getGrowthModelFertilizerUsers(dto) {
    return http.get({
      url: '/pc/growthModelFertilizerUser/getGrowthModelFertilizerUsers',
      data: dto
    })
  },
  saveGrowthModelFertilizerUser(dto) {
    return http.post({
      url: '/pc/growthModelFertilizerUser/saveGrowthModelFertilizerUser',
      data: dto,
      typea: 1
    })
  },
  exportGrowthModelFertilizerList(dto) {
    return http.post({
      url: '/pc/growthModelFertilizer/exportGrowthModelFertilizerList',
      data: dto,
      typea: 1
    })
  },
  // 删除生长模型
  delGrowthModelFertilizer(id) {
    return http.post({
      url: '/pc/growthModelFertilizer/delGrowthModelFertilizer',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },
  // 删除生长模型
  delGrowthFertilizer(id) {
    return http.post({
      url: '/pc/growthFertilizer/delGrowthFertilizer',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  // 删除生长模型
  deleteGrowthModelFertilizerUser(id) {
    return http.post({
      url: '/pc/growthModelFertilizerUser/deleteGrowthModelFertilizerUser',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },
  saveProductionRemind(dto) {
    return http.post({
      url: '/pc/productionRemind/saveProductionRemind',
      data: dto,
      typea: 1
    })
  }
}

export default apis
